module.exports = __webpack_public_path__ + "img/théâtre.daca68d0.png";